import React from "react";
import justBeach from "../assets/images/just beach.svg";
import Button from "../componentLibrary/Button";

const TOPICS = [
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1728271665518-anxiety%20tiger%20with%20grass-01.svg",
    alt: "A tiger hiding in tall grass",
    label: "Reduce Anxiety",
  },
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1727289084875-SMART%20Goals%20MAIN%20top%20of%20mountain%20and%20footsteps%20and%20flag%20artboard_top%20of%20mountain%2C%20footsteps%2C%20flag.svg",
    alt: "Footsteps leading to a flag at the top of a mountain",
    label: "Achieve Goals",
  },
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1727551387443-Conflict%20effective%20communication-02.svg",
    alt: "Two people smiling at each other. A lightbulb representing an idea floats between them",
    label: "Address Conflict",
  },
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1736194214726-Coming%20soon%20blue.svg",
    alt: "A megaphone with sound coming out of it",
    label: "Manage Stress",
  },
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1728274116506-Burnout%20main%20icon%20person%20laying%20on%20desk%20with%20low%20battery%20sign%20above%20them_A.svg",
    alt: "A person asleep at a desk",
    label: "Reduce Burnout",
  },
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1743712869992-imposter%20two%20people%20as%20one.png",
    alt: "Two People",
    label: "Overcome Imposter Syndrome",
  },
];

interface ChallengeTopicsGridProps {
  onMoreClick: () => void;
}

const ChallengeTopicsGrid = ({ onMoreClick }: ChallengeTopicsGridProps) => {
  return (
    <div className="relative">
      {/* Beach Image Background */}
      <div className="absolute inset-0 z-0">
        <img
          src={justBeach}
          alt="Beach background"
          className="w-full h-auto min-h-full object-cover object-bottom"
        />
      </div>

      {/* Transparent gradient overlay at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-15 bg-gradient-to-t from-white to-transparent z-5"></div>

      {/* Icons Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 py-8">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 text-center">
          {TOPICS.map((topic) => (
            <div key={topic.label}>
              <div className="w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                <img src={topic.src} alt={topic.alt} className="w-16 h-16" />
              </div>
              <p className="text-xl font-semibold">{topic.label}</p>
            </div>
          ))}
        </div>

        {/* +More button */}
        <div className="flex justify-center mt-12">
          <Button variant="dark" roundedFull onClick={onMoreClick}>
            +More
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChallengeTopicsGrid;
